export const Constants = {
  TAG_NAME: 'pop-pc-performance-tiles-component',
  DATA_TYPE: {
    STRING: 'string',
    NUMBER: 'number',
  },
  TILE_CONTAINER_CLASS: '.tile-container',
  VISIBLE_CLASS: 'tile-visible',
  VEHICLES: {
    SMA: 'Separately Managed Account',
  },
} as const;
